import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation() {
    const location = useLocation();
    const isAuthenticated = !!localStorage.getItem('authToken');

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        // Directly replace the location with login to avoid intermediate route flashes
        window.location.replace('/login');
    };

    return (
        <nav className="bg-gray-900/60 backdrop-blur-xl border-b border-gray-700/50 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto flex justify-between items-center h-16">
                <div className="flex items-center space-x-4">
                    <Link to="/" className="text-2xl font-bold">
                        <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
                            StockAdi
                        </span>
                    </Link>
                </div>
                <div className="flex flex-grow justify-end sm:flex items-center space-x-4">
                    <NavLink to="/dashboard" currentPath={location.pathname}>
                        Dashboard
                    </NavLink>
                    <NavLink to="/recommendations" currentPath={location.pathname}>
                        Recommendations
                    </NavLink>
                    <NavLink to="/wishlist" currentPath={location.pathname}>
                        Wishlist
                    </NavLink>
                    <NavLink to="/options" currentPath={location.pathname}>
                        Options
                    </NavLink>
                    {isAuthenticated && (
                        <button onClick={handleLogout} className="ml-2 px-3 py-1 rounded-md text-sm text-red-400 hover:text-white">
                            Logout
                        </button>
                    )}
                </div>
            </div>
        </nav>
    );
}

const NavLink = ({ to, currentPath, children }) => {
    const isActive = currentPath === to;

    return (
        <Link
            to={to}
            className={`group relative px-3 py-2 rounded-md text-sm font-medium transition-colors duration-300 ${
                isActive
                    ? 'text-white'
                    : 'text-gray-300 hover:text-white'
            }`}
        >
            {children}
            <span
                className={`absolute bottom-0 left-1/2 w-0 h-0.5 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 transition-all duration-300 ${
                    isActive ? 'w-full -translate-x-1/2' : 'group-hover:w-full group-hover:-translate-x-1/2'
                }`}
            ></span>
        </Link>
    );
};